import { createAsyncThunk } from "@reduxjs/toolkit";
import { captureException } from "@sentry/react";

import { ThunkConfig } from "@/app/providers/StoreProvider";
import { ApiError } from "@/shared/types";
import { handleError } from "@/shared/lib/helpers/utils";

interface UnCancelSubscriptionProps {
  userId: number;
}

export const unCancelSubscription = createAsyncThunk<void, UnCancelSubscriptionProps, ThunkConfig<ApiError>>(
  "subscription/unCancelSubscription",
  async (params, thunkApi) => {
    const { extra, rejectWithValue } = thunkApi;

    try {
      await extra.api.post("/api/subscription/uncancel_subscription", params);
    } catch (err) {
      captureException(err);

      return rejectWithValue(handleError(err));
    }
  }
);
